.subheading {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 52px;
  padding: 12px 16px;
  font-size: 13px;
  font-weight: 500;
  text-transform: uppercase;
  color: var(--color-text-primary);
  background: var(--color-bg-secondary);
}

.link {
  display: flex;
  padding-block: 4px;
  font-size: 13px;
  font-weight: 500;
  text-transform: none;
  text-decoration: none;
  color: inherit;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: var(--outline-focus-default);
    outline-offset: 2px;
  }

  :global(.icon) {
    width: 18px;
    height: 18px;
  }
}
